import { BIButton, BIIcon } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import styled from 'styled-components';

export const StyledParagraph = styled(DsTypography)`
  padding-left: 1.6rem;
  padding-top: 12px;
`;

export const StyledAddButton = styled(BIButton)`
  color: rgba(90, 96, 112, 0.76);
  font-family: 'Open Sans';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 16px;
`;

export const StyledAddIcon = styled(BIIcon)`
  color: rgba(90, 96, 112, 0.76);
`;
